import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Clients from './components/Clients';
import Footer from './components/Footer';
import './index.css';

const App = () => {
  return (
    <div className="font-sans antialiased bg-black text-white">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Clients />
      <Footer />
    </div>
  );
};

export default App;